import { render } from "./LeanLayout.vue?vue&type=template&id=75f5ae3a"
import script from "./LeanLayout.vue?vue&type=script&lang=js"
export * from "./LeanLayout.vue?vue&type=script&lang=js"
script.render = render

export default script